export default __webpack_public_path__ + "static/media/icon-stop-number.38744d09.svg";